export default __webpack_public_path__ + "static/media/WhereAreYouFrom_15.39645253.png";